import { connect } from 'react-redux';
import partial from 'lodash/partial';
import { toggleOffer, advanceOfferNegotiation, fetchICA, fetchUnderNegotiation } from 'entries/ducks';
import { getSubCategory } from 'common/ducks/categories';
import { getProject } from 'project/ducks/project';
import OfferModal from 'entries/components/offer_modal';

const mapStateToProps = (state) => {
  const { offeringEntry, ica } = state.entries;
  const project = getProject(state);
  const subCategory = getSubCategory(state.categories, project.sub_category);

  return {
    entry: offeringEntry,
    showing: !!offeringEntry,
    contract: { pdf: ica },
    signingAs: 'client',
    header: 'make offer',
    collapsable: true,
    uncollapseLabel: "Make offer and sign contract",
    uncollapsedTitle: "Sign the project contract",
    recommendedValue: subCategory? parseFloat(subCategory.recommended_offer_value) : 0,
  };
};

export default connect(mapStateToProps, {
  onClose: partial(toggleOffer, null),
  advanceOfferNegotiation,
  fetchICA,
  fetchUnderNegotiation
})(OfferModal);



// WEBPACK FOOTER //
// ./entries/containers/offer_modal.js